<template>
	<button
		:class="[
			'flex cursor-pointer items-center whitespace-nowrap',
			tabItemClass,
			isSelectClass,
		]"
		:disabled="isDisabled"
		ref="tabElement"
	>
		<div class="inline-flex">
			<slot v-if="!isSelected && !isDisabled" name="icon-left"></slot>
			<slot v-else-if="isSelected" name="icon-left-select"></slot>
			<slot v-else name="icon-left-disabled"></slot>
		</div>
		<span>
			<slot>text</slot>
		</span>
		<div class="inline-flex">
			<slot v-if="!isSelected && !isDisabled" name="icon-right"></slot>
			<slot v-else-if="isSelected" name="icon-right-select"></slot>
			<slot v-else name="icon-right-disabled"></slot>
		</div>
	</button>
</template>

<script setup lang="ts">
import { computed, ref, type PropType } from 'vue'

const props = defineProps({
	type: {
		type: String as PropType<'primary' | 'secondary'>,
		required: true,
	},
	size: {
		type: String as PropType<'large' | 'medium'>,
		required: true,
	},
	isSelected: {
		type: Boolean,
		default: false,
	},
	isDisabled: {
		type: Boolean,
		default: false,
	},
})

const tabElement = ref(null)

defineExpose({
	tabElement,
})

const tabItemClass = computed(() => {
	const classes = {
		primary: {
			base: 'border-none gap-8px text-n-950 px-12px hover:bg-b-5% active:bg-b-10% hover:rounded-[6px] active:rounded-[6px]',
			size: {
				large: 'py-12px typography-s1-emp',
				medium: 'py-8px typography-s2-emp',
			},
		},
		secondary: {
			base: 'rounded-full border border-n-100 py-8px hover:border-n-950 active:border-n-950 active:bg-b-10% disabled:bg-n-50 disabled:bg-n-300 disabled:text-n-300 disabled:border-n-100 disabled:cursor-not-allowed',
			size: {
				large: 'px-12px gap-8px typography-s1-emp mdp:px-16px mdp:py-12px',
				medium: 'px-[10px] mdp:px-12px gap-4px typography-s2-emp',
			},
		},
	}
	const baseClass = classes[props.type]?.base || ''
	const sizeClass = classes[props.type]?.size[props.size] || ''

	return `${baseClass} ${sizeClass}`
})

const isSelectClass = computed(() => {
	if (!props.isSelected) return 'bg-white'
	const classes = {
		primary:
			'border border-n-950 text-white rounded-[6px] bg-n-950 [&&]:hover:bg-n-950',
		secondary: 'border border-n-950 text-white bg-n-950 [&&]:hover:bg-n-950',
	}

	return classes[props.type] || ''
})
</script>
